/**
 * Hisobot ustunlari va holat kodlarining o'zbekcha nomlari.
 *
 * Hisobot jadvallari serverdan KELGAN ustun kalitlari bilan
 * chiziladi (`employee_id`, `on_hand_qty`). Kalitni shundayligicha
 * ko'rsatish xodimdan inglizcha va sxema nomlarini bilishni talab
 * qilardi. Lug'atda yo'q kalit avvalgidek ko'rinadi — yangi ustun
 * qo'shilganda jadval buzilmaydi, faqat nomi xom qoladi.
 */
export const COLUMN_LABELS: Record<string, string> = {
  abc_class: "ABC sinfi",
  abc_xyz: "ABC/XYZ",
  active_period_count: "Faol davrlar",
  actual_qty: "Fakt",
  assignee_id: "Ijrochi",
  available_qty: "Mavjud",
  block_id: "Blok",
  blocked: "Bloklangan",
  blocked_locations: "Bloklangan kataklar",
  bucket_date: "Sana",
  capacity_pallets: "Sig'im, pallet",
  cell_type: "Katak turi",
  check_status: "Tekshiruv",
  classified_at: "Tasniflandi",
  collected_qty: "Yig'ilgan",
  completed_at: "Yakunlandi",
  count_task_id: "Sanash topshirig'i",
  count_task_ids: "Sanash topshiriqlari",
  created_at: "Yaratildi",
  current_status: "Holat",
  decided_at: "Qaror vaqti",
  delta_qty: "Farq",
  detected_at: "Aniqlandi",
  direction: "Yo'nalish",
  discrepancy_type: "Tafovut turi",
  distinct_sku_count: "SKU soni",
  employee_id: "Xodim",
  error_message: "Xato",
  excess_count: "Ortiqcha",
  forecast_daily_qty: "Kunlik prognoz",
  free_slots: "Bo'sh joy",
  has_barcode: "Shtrix-kod",
  has_complete_vgh: "VGH to'liq",
  has_photo: "Foto",
  has_shortage: "Kamomad bor",
  height_cm: "Balandlik, sm",
  held_days: "Ushlangan kun",
  idle_bucket: "Harakatsizlik oralig'i",
  idle_days: "Harakatsiz kun",
  idle_hours: "Harakatsiz soat",
  ikpu_code: "ИКПУ",
  in_transit_qty: "Yo'lda",
  is_active: "Faol",
  issues: "Muammolar",
  last_movement_at: "Oxirgi harakat",
  length_cm: "Uzunlik, sm",
  line_count: "SKU",
  location_abc_zone: "Katak ABC zonasi",
  location_code: "Katak",
  location_count: "Katak soni",
  location_function: "Katak vazifasi",
  lot_ref: "Partiya",
  lp_id: "Pallet (LP)",
  manager_decision: "Menejer qarori",
  manager_note: "Menejer izohi",
  max_weight_kg: "Maks. vazn, kg",
  mx_qty: "MX qoldig'i",
  occupied_slots: "Band joy",
  on_hand_qty: "Qoldiq",
  order_id: "Buyurtma",
  order_number: "Buyurtma raqami",
  other_qty: "Boshqa",
  penalty_count: "Jarima",
  period_count: "Davrlar",
  period_mean_qty: "O'rtacha, davr",
  pick_count: "Terish soni",
  planned_qty: "Reja",
  process: "Jarayon",
  product_group: "Tovar guruhi",
  putaway_allowed: "Joylashtirishga ruxsat",
  quality_status: "Sifat",
  reason: "Sabab",
  remaining_qty: "Qolgan",
  requested_qty: "Talab",
  reserved_qty: "Band",
  resolution: "Yechim",
  resolved_at: "Hal qilindi",
  shortage_count: "Kamomad",
  sku_abc_class: "SKU ABC sinfi",
  sku_article: "Artikul",
  sku_name: "Tovar",
  source_process: "Manba jarayon",
  started_at: "Boshlandi",
  status: "Holat",
  stop_reason: "To'xtash sababi",
  stored_weight_kg: "Saqlangan vazn, kg",
  task_count: "Topshiriq",
  task_id: "Topshiriq",
  task_type: "Topshiriq turi",
  tnved_code: "ТНВЭД",
  variation_coefficient: "O'zgaruvchanlik",
  wait_seconds: "Kutish",
  waiting_for: "Nimani kutmoqda",
  waiting_reason: "Kutish sababi",
  warehouse_code: "Ombor",
  weight_fits: "Vazn sig'adi",
  weight_kg: "Vazn, kg",
  width_cm: "Eni, sm",
  work_seconds: "Ish vaqti",
  xyz_class: "XYZ sinfi",
  xyz_note: "XYZ izohi",
  zone_code: "Zona",
};

export function columnLabel(column: string): string {
  return COLUMN_LABELS[column] ?? column.replace(/_/g, " ");
}

/**
 * Holat kodlarining o'zbekcha nomi.
 *
 * Kod o'zi `title` da qoladi: xodim xizmat bilan gaplashganda
 * `INCOMPLETE` deyishi kerak bo'lishi mumkin.
 */
export const STATUS_LABELS: Record<string, string> = {
  // Umumiy
  CREATED: "Yaratildi",
  RESERVED: "Rezervlangan",
  ACCEPTED: "Qabul qilindi",
  ASSIGNED: "Biriktirildi",
  IN_PROGRESS: "Bajarilmoqda",
  COMPLETED: "Yakunlandi",
  CANCELLED: "Bekor qilindi",
  PENDING: "Navbatda",
  DRAFT: "Qoralama",
  ACTIVE: "Faol",
  CLOSED: "Yopilgan",
  APPROVED: "Tasdiqlandi",
  REJECTED: "Rad etildi",
  DECIDED: "Qaror qabul qilindi",
  RESOLVED: "Hal qilindi",
  OPEN: "Ochiq",
  REVIEW: "Ko'rib chiqilmoqda",
  // Kirim
  EXPECTED: "Kutilmoqda",
  ARRIVED: "Keldi",
  RECEIVING: "Qabul qilinmoqda",
  // Chiqim
  ALLOCATED: "Taqsimlandi",
  PICKED: "Terildi",
  INCOMPLETE: "To'liq emas",
  HANDED_OFF: "Nazoratga uzatildi",
  PARTIAL: "Qisman",
  SHORT: "Kam",
  STAGING: "OTGga yig'ilmoqda",
  LOADING: "Yuklanmoqda",
  SHIPPED: "Jo'natildi",
  RETURNING: "Qaytarilmoqda",
  // Tafovut va kutish
  SHORTAGE: "Kamomad",
  EXCESS: "Ortiqcha",
  DISCREPANCY: "Tafovut",
  COUNTED: "Sanaldi",
  WAITING_MANAGER: "Menejer qarorini kutmoqda",
  WAITING_INVENTORY: "Inventarizatsiyani kutmoqda",
  WAITING_DEPENDENCY: "Bog'liqlikni kutmoqda",
  BLOCKED: "Bloklangan",
  // Inventarizatsiya
  POINT: "Nuqtaviy",
  FULL: "To'liq",
  COUNTING: "Sanalmoqda",
  // Integratsiya
  APPLIED: "Qo'llandi",
  DELIVERED: "Yetkazildi",
  DEAD_LETTER: "Yetkazilmadi",
  WAITING_MAPPING: "Mapping kutmoqda",
  MANUAL_REVIEW: "Qo'lda ko'rib chiqish",
  SENT: "Yuborildi",
  FAILED: "Xato",
  // Topshiriq turlari va jarayonlar
  RECEIPT: "Qabul",
  CONTROL: "Nazorat",
  PUTAWAY: "Joylashtirish",
  PICK: "Terish",
  PICKING: "Terish",
  REPLENISHMENT: "To'ldirish",
  SHIPMENT: "Jo'natish",
  SHIPPING: "Jo'natish",
  COUNT: "Inventarizatsiya",
  INVENTORY: "Inventarizatsiya",
  PRODUCTION: "Ishlab chiqarish",
  MOVE: "Ko'chirish",
  REPACK: "Qayta palletlash",
  RETURN_TO_MX: "MXga qaytarish",
  // Kara ishlari (TZ §3): pallet MX dan sariqqa TUSHIRILADI va
  // qoldiq bilan qizildan MXga KO'TARILADI.
  PALLET_LOWER: "Tushirish",
  PALLET_LIFT: "Ko'tarish",
  WAITING: "Pallet kutilmoqda",
  B_TO_A_TRANSFER: "B→A ko'chirish",
  TASK: "Topshiriq",
  INBOUND: "Kirim",
  // Sifat
  AVAILABLE: "Mavjud",
  QUARANTINE: "Karantin",
  DEFECT: "Brak",
  QUALITY_CHECK: "Sifat tekshiruvida",
  CUSTOMS_HOLD: "Bojxonada ushlangan",
  // Ustuvorlik
  CRITICAL: "Kritik",
  HIGH: "Yuqori",
  NORMAL: "Oddiy",
  LOW: "Past",
  // LP (logistika birligi) holati
  EMPTY: "Bo'sh",
  BUFFER: "Bufer",
  WITH_EMPLOYEE: "Xodim qo'lida",
  CONSUMED: "Sarflandi",
  ARCHIVED: "Arxivlandi",
  // Joy funksiyasi, zona va hudud
  MX: "MX — saqlash",
  OX: "OX — terish",
  YELLOW: "Sariq hudud",
  RED: "Qizil hudud",
  STORAGE: "Saqlash",
  CUSTOMS: "Bojxona",
  RETURN: "Qaytarish",
  VIRTUAL: "Virtual",
  OPERATIONAL: "Operatsion",
  RACK: "Stellaj",
  FLOOR: "Pol",
  // Katak turi (o'lchamlar TZ §4.2–4.4)
  // Yacheyka turi nomida TERISH so'zi: xodim «Y1» kodini
  // yodlab yurmasligi kerak, unga katak nima uchunligi muhim.
  Y1: "Y1 — mayda terish",
  Y2: "Y2 — terish",
  PL: "PL — 1 pallet",
  PL05: "PL 0.5 — yarim pallet",
  P1: "P1 — 1 pallet",
  P2: "P2 — 2 pallet",
  P3: "P3 — 3 pallet",
  P4: "P4 — 4 pallet",
  OP: "OP — operatsion",
  // Joylashtirish zona qoidasi
  NEAREST_FREE: "Eng yaqin bo'sh joy",
  ZONE_A: "A zonasi",
  ZONE_B: "B zonasi",
  ZONE_C: "C zonasi",
  SKU_CLASS: "SKU tasnifi bo'yicha",
  DEFAULT_RULE: "Standart qoida (tarixsiz SKU)",
  // Topshiriq va reja holati
  PLANNED: "Rejalashtirildi",
  READY: "Tayyor",
  SCANNED: "Skanerlandi",
  TAKEN_FROM_MX: "MXdan olindi",
  IN_YELLOW: "Sariqda",
  IN_RED: "Qizilda",
  RETURNED_TO_MX: "MXga qaytarildi",
  LOCATION_RESERVED: "Joy rezervlandi",
  CONFIRMED: "Tasdiqlandi",
  MATCHED: "Mos keldi",
  RECOUNT: "Qayta sanash",
  SKIPPED: "O'tkazib yuborildi",
  ABANDONED: "Tashlab ketildi",
  // TSD qadamlari (dev_spec §10.4)
  SCAN_SOURCE: "Manbani skanerlash",
  SCAN_LP: "LP ni skanerlash",
  SCAN_TARGET: "Maqsadni skanerlash",
  CONFIRM_QTY: "Miqdorni tasdiqlash",
  CONFIRM_DROP: "Qo'yishni tasdiqlash",
  SELECT_SECTOR: "Sektorni tanlash",
  PHOTO: "Foto",
  NOTE: "Izoh",
  // Nazorat va jo'natish
  STAGED: "OTGga yig'ildi",
  LOADED: "Yuklandi",
  RELEASED_TO_SHIP: "Jo'natishga ruxsat berildi",
  CONTROLLED: "Nazoratdan o'tdi",
  INSPECTING: "Ko'rikdan o'tmoqda",
  INSPECTED: "Ko'rikdan o'tdi",
  PRODUCED: "Ishlab chiqarildi",
  ISSUED: "Berildi",
  // Terish rejimi va menejer qarori
  WHOLE_PALLET: "Butun pallet",
  BOX: "Korobka",
  CANCEL_LINE: "SKU ni bekor qilish",
  SHIP_PARTIAL: "Qisman jo'natish",
  // Kamomadni nazoratchi hal qiladi (buyurtmachi, 2026-11-03).
  CONTROLLER_SHIP_PARTIAL: "Nazoratchi: sanalgan miqdor jo'natildi",
  WAIT_SUPPLY: "Yetkazib berishni kutish",
  WRITE_OFF: "Hisobdan chiqarish",
  WRITEOFF: "Hisobdan chiqarish",
  // Rezerv
  RELEASED: "Bo'shatildi",
  COMMITTED: "Qat'iylashtirildi",
  EXPIRED: "Muddati o'tdi",
  REQUESTED: "So'raldi",
  REVOKED: "Chaqirib olindi",
  REGISTERED: "Qayd etildi",
  SUPPLIER_RETURN: "Ta'minotchiga qaytarish",
  // Harakat turi
  ADJUSTMENT: "Tuzatish",
  OPENING_BALANCE: "Boshlang'ich qoldiq",
  PRODUCTION_ISSUE: "Ishlab chiqarishga berish",
  PRODUCTION_OUTPUT: "Ishlab chiqarish natijasi",
  QUALITY_CHANGE: "Sifat o'zgarishi",
  REVERSAL: "Qaytarib olish (storno)",
  // Blok sababi
  MANUAL: "Qo'lda",
  DAMAGE: "Shikast",
  DATA_ERROR: "Ma'lumot xatosi",
  LOCATION_MISMATCH: "Joy mos emas",
  RESERVATION_CONFLICT: "Rezerv to'qnashuvi",
  TEMPORARY_OCCUPANCY: "Vaqtincha band",
  ALL: "Hammasi",
  BLOCK: "Bloklash",
  RECONCILE: "Solishtirish",
  // Hisobdan chiqarish va qaytarish sababi
  LOST: "Yo'qoldi",
  SAMPLE: "Namuna",
  OTHER: "Boshqa",
  // Tafovut qarori
  MOVED_TO_DISCREPANCY: "Tafovut joyiga ko'chirildi",
  MOVED_TO_SYSTEM_LOCATION: "Tizim joyiga ko'chirildi",
  NEW_LP_TO_DISCREPANCY: "Yangi LP tafovut joyiga",
  SHORTAGE_REGISTERED: "Kamomad qayd etildi",
  EXCESS_REGISTERED: "Ortiqcha qayd etildi",
  // Qayta urinish (manba almashtirish)
  ORIGINAL: "Asl manba",
  ALTERNATIVE: "Almashtirilgan manba",
  FOUND: "Topildi",
  NOT_FOUND: "Topilmadi",
  RETRY_ISSUED: "Qayta urinish berildi",
  // 1C integratsiyasi
  DISPATCHED: "Servisga yuborildi",
  SUPERSEDED: "Eskirdi (yangi versiya bor)",
  OUTBOUND: "Chiqim",
  SAR: "SAR — tovarlar",
  SKH: "SKH — kontragentlar",
  SPR: "SPR — kirim buyurtmalari",
  SSL: "SSL — chiqim buyurtmalari",
  // Solishtirish kesimi va hukmi
  ENTITY_VERSIONS: "Obyekt versiyalari",
  DELIVERY_ACK: "Yetkazish tasdig'i",
  RECEIPT_SHIPMENT: "Kirim va chiqim hujjatlari",
  INVENTORY_SLICE: "Inventarizatsiya kesimi",
  MATCH: "Mos",
  MISMATCH: "Mos emas",
  MISSING_IN_1C: "1C da yo'q",
  MISSING_IN_WMS: "WMS da yo'q",
  // Mapping turi
  WAREHOUSE: "Ombor",
  UOM: "O'lchov birligi",
  ROLE: "Rol",
  // Xabarnoma holati va kanali
  SENDING: "Yuborilmoqda",
  READ: "O'qildi",
  DEAD: "Urinishlar tugadi",
  IN_APP: "Ilova ichida",
  EMAIL: "Email",
  TELEGRAM: "Telegram",
  // Xabarnoma qoidalari
  LP_MISMATCH: "LP topshiriqqa mos emas",
  ORDER_INCOMPLETE: "Buyurtma to'liq terilmadi",
  ZONE_DELAY: "Hududda kechikish",
  INTEGRATION_ERROR: "1C integratsiyasi xatosi",
  // Kontragent roli
  SUPPLIER: "Ta'minotchi",
  CUSTOMER: "Mijoz",
  CARRIER: "Tashuvchi",
  OWNER: "Egasi",
  COUNTERPARTY: "Kontragent",
  SKU: "Tovar",
  PACKAGE: "Qadoq",
  // Media maqsadi va shtrixkod turi
  SKU_PHOTO: "Tovar foto",
  RECEIPT_PHOTO: "Qabul foto",
  DAMAGE_PHOTO: "Shikast foto",
  COUNT_PHOTO: "Inventarizatsiya foto",
  DISCREPANCY_PHOTO: "Tafovut foto",
  DOCUMENT: "Hujjat",
  LABEL: "Yorliq",
  CODE128: "Code 128",
  EAN13: "EAN-13",
  EAN8: "EAN-8",
  QR: "QR",
  // Antivirus tekshiruvi
  CLEAN: "Toza",
  INFECTED: "Zararlangan",
  ERROR: "Xato",
  // LP va tara turi
  CONTAINER: "Tara",
  PALLET: "Pallet",
  // Texnika
  FORKLIFT: "Kara",
  PICKER: "Terish texnikasi",
  // Eksport
  CSV: "CSV",
  XLSX: "Excel (XLSX)",
  QUEUED: "Navbatda",
  RUNNING: "Bajarilmoqda",
  // Bojxona holati
  CLEARED: "Rasmiylashtirildi",
  HOLD: "Ushlangan",
  NONE: "Yo'q",
  // Sozlama: qiymat turi, guruh va manba
  STRING: "Matn",
  INTEGER: "Butun son",
  DECIMAL: "O'nlik son",
  BOOLEAN: "Ha/yo'q",
  DURATION: "Davomiylik",
  LIST: "Ro'yxat",
  OBJECT: "Obyekt",
  FEATURE_FLAG: "Modul bayrog'i",
  NOTIFICATION: "Xabarnoma",
  RETENTION: "Saqlash muddati",
  SCHEDULER: "Jadval",
  SLA: "SLA",
  SLOTTING: "Joylashtirish",
  GLOBAL: "Umumiy",
  GLOBAL_ONLY: "Faqat umumiy",
  DEFAULT: "Standart",
  // Audit va manba
  API: "API",
  EVENT: "Hodisa",
  SCAN: "Skanerlash",
  SCHEDULE: "Jadval bo'yicha",
  // ABC/XYZ izohi
  NO_DEMAND: "Talab yo'q",
  SHORT_HISTORY: "Tarix qisqa",
  UNKNOWN: "Noma'lum",
  VALIDATING: "Tekshirilmoqda",
  VALIDATED: "Tekshirildi",
  APPEALED: "Apellyatsiya berildi",
  FOREIGN_STOCK: "Begona qoldiq",
  ORDER: "Buyurtma",
  // Hodisa turlari (audit va topshiriq tarixi)
  SESSION_CREATED: "Sessiya yaratildi",
  ORDER_CREATED: "Buyurtma yaratildi",
  PLAN_CREATED: "Reja yaratildi",
  CANDIDATES_EVALUATED: "Manbalar baholandi",
  SOURCE_SCANNED: "Manba skanerlandi",
  SOURCE_MISMATCH: "Manba mos emas",
  LOCATION_SCANNED: "Joy skanerlandi",
  STATION_SCANNED: "Stol skanerlandi",
  LP_SCANNED: "LP skanerlandi",
  ITEM_SCANNED: "Tovar skanerlandi",
  CONTAINER_SCANNED: "Tara skanerlandi",
  CONTAINER_REPACKED: "Tara qayta yig'ildi",
  QUANTITY_CONFIRMED: "Miqdor tasdiqlandi",
  OX_CONFIRMED: "OX tasdiqlandi",
  YELLOW_CONFIRMED: "Sariqda tasdiqlandi",
  RED_CONFIRMED: "Qizilda tasdiqlandi",
  LINE_COMPLETED: "SKU yakunlandi",
  LP_CLOSED: "LP yopildi",
  HANDED_OFF_CONTROL: "Nazoratga uzatildi",
  REALLOCATED: "Qayta taqsimlandi",
  RESELECTED: "Manba qayta tanlandi",
  ALTERNATIVE_ISSUED: "Almashtirilgan manba berildi",
  RETRY_RESULT: "Qayta urinish natijasi",
  SOURCES_SENT_TO_COUNT: "Manbalar inventarizatsiyaga yuborildi",
  MANAGER_DECISION: "Menejer qarori",
  CANCEL_RETURN_COMPLETED: "Bekor qilib qaytarish yakunlandi",
  PENALTY_CREATED: "Jarima yozildi",
  PENALTY_CORRECTED: "Jarima tuzatildi",
};

export function statusLabel(value: string): string {
  return STATUS_LABELS[value.toUpperCase()] ?? value;
}

/**
 * Rol kodlarining o'zbekcha nomlari.
 *
 * Holat lug'atidan ALOHIDA: rol kodi holat kodi bilan to'qnashadi —
 * `picker` roli «Teruvchi», `PICKER` texnikasi esa «Terish
 * texnikasi». Bitta lug'atda biri ikkinchisini bosib ketardi.
 *
 * Ro'yxatda identity rollari va sozlama mas'ullari (TZ §20.1) bor.
 */
export const ROLE_LABELS: Record<string, string> = {
  administrator: "Administrator",
  warehouse_manager: "Ombor rahbari",
  dispatcher: "Dispetcher",
  receiver: "Qabul qiluvchi",
  forklift_driver: "Kara haydovchisi",
  picker: "Teruvchi",
  controller: "Nazoratchi",
  shipper: "Jo'natish xodimi",
  inventory_counter: "Inventarizator",
  senior_staff: "Katta xodim",
  order_manager: "Buyurtma menejeri",
  production_worker: "Ishlab chiqarish xodimi",
  return_clerk: "Vozvrat xodimi",
  replenisher: "To'ldiruvchi",
  integration_1c: "1C integratsiyasi",
  // Sozlama mas'ullari — identity roli emas, TZ §20.1 dagi tomonlar.
  business_owner: "Biznes egasi",
  warehouse_specialist: "Ombor mutaxassisi",
  integration_specialist: "1C mutaxassisi",
};

export function roleLabel(value: string): string {
  return ROLE_LABELS[value.toLowerCase()] ?? value;
}
